module.exports = __webpack_public_path__ + "img/option-print-resi.e8b9daa4.png";